/* «¡Escribe tu opinión!» (10/10/2026): abre el modal de
 * `snippets/natnatura-opinar.liquid` y manda la opinión a Judge.me.
 *
 * El envío es el del widget de Judge.me (`write_review_modal.js`, leído el
 * 10/10): POST multipart a https://api.judge.me/api/v1/reviews con
 * `url`/`shop_domain` (el .myshopify), `platform`, `id` del producto,
 * `rating`, `name`, `email` y `body`. Es público: no lleva clave. La tienda
 * tiene la publicación automática apagada, así que la opinión entra
 * PENDIENTE y solo sale en la ficha cuando la clienta la aprueba.
 *
 * Todo por delegación en `document`: `theme dev` sustituye la sección en
 * cada recarga en caliente y mata los oyentes puestos en el nodo. El scroll
 * se bloquea con el atributo de Horizon (`scroll-lock` en `<html>`), y el
 * propio diálogo lo lleva para que el pop-up de captación y la ventana del
 * test sepan que hay un modal abierto y no lo quiten al cerrarse ellos.
 */
(() => {
  if (window.NNOpinar) return;
  window.NNOpinar = true;

  const ENDPOINT = 'https://api.judge.me/api/v1/reviews';
  const CORREO = /^[^\s@]+@[^\s@]+\.[^\s@]{2,}$/;

  const abrir = (dialogo, origen) => {
    if (dialogo.open) return;
    dialogo._origen = origen;
    reiniciar(dialogo);
    dialogo.setAttribute('scroll-lock', '');
    document.documentElement.setAttribute('scroll-lock', '');
    dialogo.showModal();
  };

  const cerrar = (dialogo) => {
    if (!dialogo.open || dialogo.classList.contains('nn-opinar--cerrando')) return;
    const fin = () => {
      dialogo.classList.remove('nn-opinar--cerrando');
      dialogo.close();
    };
    if (window.matchMedia('(prefers-reduced-motion: reduce)').matches) fin();
    else {
      dialogo.classList.add('nn-opinar--cerrando');
      setTimeout(fin, 220);
    }
  };

  const reiniciar = (dialogo) => {
    const form = dialogo.querySelector('[data-nn-opinar-formulario]');
    if (dialogo.dataset.enviada === '1') {
      form.reset();
      delete dialogo.dataset.enviada;
    }
    dialogo.querySelector('[data-nn-opinar-paso="formulario"]').hidden = false;
    dialogo.querySelector('[data-nn-opinar-paso="gracias"]').hidden = true;
    dialogo.querySelectorAll('[data-nn-opinar-error], [data-nn-opinar-error-envio]').forEach((e) => {
      e.hidden = true;
      e.textContent = '';
    });
    dialogo.querySelectorAll('[aria-invalid]').forEach((e) => e.removeAttribute('aria-invalid'));
  };

  const marcar = (dialogo, campo, texto) => {
    const caja = dialogo.querySelector(`[data-nn-opinar-campo="${campo}"]`);
    if (!caja) return;
    const error = caja.querySelector('[data-nn-opinar-error]');
    const entrada = caja.querySelector('input:not([type="radio"]), textarea') || caja.querySelector('input');
    if (texto) {
      error.textContent = texto;
      error.hidden = false;
      if (entrada) entrada.setAttribute('aria-invalid', 'true');
    } else {
      error.textContent = '';
      error.hidden = true;
      if (entrada) entrada.removeAttribute('aria-invalid');
    }
  };

  const validar = (dialogo, form) => {
    const d = dialogo.dataset;
    const datos = new FormData(form);
    const fallos = [];
    const comprobar = (campo, texto) => {
      marcar(dialogo, campo, texto);
      if (texto) fallos.push(campo);
    };
    comprobar('rating', datos.get('rating') ? '' : d.textoFaltaNota);
    const email = (datos.get('email') || '').trim();
    comprobar('email', !email ? d.textoFaltaCampo : CORREO.test(email) ? '' : d.textoEmailMal);
    comprobar('name', (datos.get('name') || '').trim() ? '' : d.textoFaltaCampo);
    comprobar('body', (datos.get('body') || '').trim() ? '' : d.textoFaltaCampo);
    comprobar('legal', datos.get('legal') ? '' : d.textoFaltaLegal);
    if (fallos.length) {
      const primero = dialogo.querySelector(`[data-nn-opinar-campo="${fallos[0]}"] input, [data-nn-opinar-campo="${fallos[0]}"] textarea`);
      if (primero) primero.focus();
      return null;
    }
    return {
      rating: datos.get('rating'),
      email,
      name: datos.get('name').trim(),
      body: datos.get('body').trim(),
    };
  };

  const enviar = async (dialogo, form) => {
    const valores = validar(dialogo, form);
    if (!valores) return;
    const boton = form.querySelector('[data-nn-opinar-enviar]');
    const aviso = dialogo.querySelector('[data-nn-opinar-error-envio]');
    const textoBoton = boton.textContent;
    aviso.hidden = true;
    boton.disabled = true;
    boton.textContent = dialogo.dataset.textoEnviando;

    const cuerpo = new FormData();
    const tienda = dialogo.dataset.tienda;
    cuerpo.append('url', tienda);
    cuerpo.append('shop_domain', tienda);
    cuerpo.append('platform', 'shopify');
    cuerpo.append('id', dialogo.dataset.producto);
    Object.entries(valores).forEach(([k, v]) => cuerpo.append(k, v));

    try {
      const r = await fetch(ENDPOINT, { method: 'POST', body: cuerpo });
      if (!r.ok) throw new Error(`Judge.me ${r.status}`);
      dialogo.dataset.enviada = '1';
      dialogo.querySelector('[data-nn-opinar-paso="formulario"]').hidden = true;
      dialogo.querySelector('[data-nn-opinar-paso="gracias"]').hidden = false;
      dialogo.querySelector('[data-nn-opinar-gracias]').focus();
    } catch (e) {
      console.warn('[natnatura-opinar]', e);
      aviso.textContent = dialogo.dataset.textoError;
      aviso.hidden = false;
    } finally {
      boton.disabled = false;
      boton.textContent = textoBoton;
    }
  };

  document.addEventListener('click', (e) => {
    const abre = e.target.closest('[data-nn-opinar-abrir]');
    if (abre) {
      const dialogo = document.getElementById(abre.dataset.nnOpinarAbrir);
      if (dialogo) abrir(dialogo, abre);
      return;
    }
    const cierra = e.target.closest('[data-nn-opinar-cerrar]');
    if (cierra) {
      cerrar(cierra.closest('dialog'));
      return;
    }
    // Clic en el velo: el destino es el propio diálogo, que ocupa la
    // pantalla; la caja de verdad va dentro.
    if (e.target.matches && e.target.matches('dialog[data-nn-opinar]')) cerrar(e.target);
  });

  document.addEventListener('submit', (e) => {
    const form = e.target.closest('[data-nn-opinar-formulario]');
    if (!form) return;
    e.preventDefault();
    enviar(form.closest('dialog'), form);
  });

  // Al corregir un campo, su aviso se va.
  document.addEventListener('input', (e) => {
    const caja = e.target.closest('[data-nn-opinar-campo]');
    const dialogo = e.target.closest('dialog[data-nn-opinar]');
    if (caja && dialogo) marcar(dialogo, caja.dataset.nnOpinarCampo, '');
  });

  // Escape: que salga con la misma animación que la cruz.
  document.addEventListener('cancel', (e) => {
    if (e.target.matches && e.target.matches('dialog[data-nn-opinar]')) {
      e.preventDefault();
      cerrar(e.target);
    }
  }, true);

  document.addEventListener('close', (e) => {
    const dialogo = e.target;
    if (!dialogo.matches || !dialogo.matches('dialog[data-nn-opinar]')) return;
    dialogo.removeAttribute('scroll-lock');
    if (!document.querySelector('dialog[open][scroll-lock], dialog.nn-captacion--modal[open]')) {
      document.documentElement.removeAttribute('scroll-lock');
    }
    if (dialogo._origen && document.contains(dialogo._origen)) dialogo._origen.focus();
  }, true);
})();
